module.exports = __webpack_public_path__ + "static/media/image-diagram-campaign-donate-pc.0cf667b9.png";